import flattenDeep from 'lodash/flattenDeep';

import { useInfiniteQuery } from '@gogame/query';

import { actionsLog } from './queryKeyFactory';

export const useLoadLogs = (id, source) => {
  const LIMIT = 15;

  return useInfiniteQuery(
    actionsLog(id),
    ({ pageParam = 0 }) => {
      return source({
        id,
        limit: LIMIT,
        offset: pageParam,
      });
    },
    {
      staleTime: Infinity,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = flattenDeep(allPages).length;

        return lastPage.length === LIMIT ? nextPage : undefined;
      },
    }
  );
};
